module.exports = __webpack_public_path__ + "static/media/chevron-back-white.d6ce79f0.svg";